<!--
 * @Author: 陈朝晖
 * @Date: 2021-05-13 14:51:15
 * @LastEditTime: 2024-10-24 15:24:51
 * @Description: 
-->

<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";
export default {
  name: "app",
  mounted() {
    this.routerHandler();
  },
  methods: {
    routerHandler() {
      this.$router.beforeEach((to, from, next) => {
        // 数据未全部请求完成，拒绝路由跳转

        // 切换路由加载对应js时显示顶部进度条
        NProgress.start();

        next();
      });

      this.$router.afterEach(() => {
        // 路由加载完成，关闭顶部进度条
        NProgress.done();
      });
    },
  },
  created() {
    this.$router.afterEach((to, from, next) => {
      this.$store.commit("setRoutePath", to.path);
      if (to.path.startsWith("/offers")) {
        document.querySelector("body").classList.add("offers-body");
      } else {
        document.querySelector("body").classList.remove("offers-body");
      }
    });
    this.$store.dispatch("setOperateAsync");
    this.$store.dispatch("setIntegralAsync");
  },
};
</script>

<style lang="scss">
.el-picker-panel__shortcut:hover {
  color: #ff5500 !important;
}
.start-date > div > span {
  color: #fff !important;
  background-color: #ff5500 !important;
}
.today > div > span {
  color: #ff5500 !important;
}
.end-date > div > span {
  color: #fff !important;
  background-color: #ff5500 !important;
}

::-webkit-scrollbar-track-piece {
  //滚动条凹槽的颜色，还可以设置边框属性
  background-color: #f8f8f8;
}
::-webkit-scrollbar {
  //滚动条的宽度
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-thumb {
  //滚动条的设置
  background-color: #dddddd;
  background-clip: padding-box;
  min-height: 28px;
  cursor: pointer;
  border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #bbb;
}

#nprogress .bar {
  background: lightgreen;
}
</style>
